import { useForm } from '@refinedev/antd';
import { Edit } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch, Select } from 'antd';

export const CancellationReasonEdit = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/cancellation-reasons',
    redirect: 'list',
  });

  return (
    <Edit saveButtonProps={saveButtonProps} title="Bekor qilish sababini tahrirlash">
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Turi"
          name="actorType"
          rules={[{ required: true, message: 'Turini tanlang' }]}
        >
          <Select>
            <Select.Option value="CLIENT">Mijoz</Select.Option>
            <Select.Option value="DRIVER">Haydovchi</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Sabab (O'zbekcha)"
          name="reasonUz"
          rules={[{ required: true, message: 'Sababni kiriting' }]}
        >
          <Input placeholder="Sabab..." />
        </Form.Item>

        <Form.Item
          label="Sabab (Ruscha)"
          name="reasonRu"
          rules={[{ required: true, message: 'Sababni kiriting' }]}
        >
          <Input placeholder="Причина..." />
        </Form.Item>

        <Form.Item
          label="Sabab (Inglizcha)"
          name="reasonEn"
          rules={[{ required: true, message: 'Sababni kiriting' }]}
        >
          <Input placeholder="Reason..." />
        </Form.Item>

        <Form.Item label="Tartib raqami" name="sortOrder">
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Faol" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
};
